// Store random users
// eslint-disable-next-line import/prefer-default-export
export function storeRandomUsers(payload) {
  return { type: 'random-users:store', payload };
}
